import React, { useState } from 'react';
import Navbar from 'modules/common/components/navbar';
import { useDispatch, useSelector } from 'react-redux';
import { RadioGroup } from '@headlessui/react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import toast, { Toaster } from 'react-hot-toast';
import { checkConnectivity } from 'modules/home/selectors';
import ChangeModel from 'modules/common/components/modal';
import { getAdminsSlice } from './slice';
import {
  getAdminsList,
  removeAdminsSuccess,
  removeAdminsLoader,
  getMasterAdmin,
  changeAdminsLoader,
  changeAdminsSuccess,
} from './selectors';

// import { deleteAdmin } from './functions';

// const people = [
//   {
//     name: 'Kavi G.',
//     title: '0xfB844fbf0a8517C2A7bA1630683FEA6A37c8d186',
//     email: 'proooogrammer@gmail.com',
//     role: 'Admin',
//   },
//   // More people...
// ];

function CheckIcon(props) {
  return (
    <svg viewBox='0 0 24 24' fill='none' {...props}>
      <circle cx={12} cy={12} r={12} fill='#fff' opacity='0.2' />
      <path
        d='M7 13l3 3 7-7'
        stroke='#fff'
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

const Admin = () => {
  const dispatch = useDispatch();
  const adminsList = useSelector(getAdminsList);
  const removeLoader = useSelector(removeAdminsLoader);
  const removeSuccess = useSelector(removeAdminsSuccess);
  const connectivity = useSelector(checkConnectivity);
  const master = useSelector(getMasterAdmin);
  const changeLoading = useSelector(changeAdminsLoader);
  const changeSuccess = useSelector(changeAdminsSuccess);

  const [selected, setSelected] = useState(adminsList[0]);
  const [isOpen, setIsOpen] = useState(false);

  const removeAdmin = async (id) => {
    await Promise.resolve(dispatch(getAdminsSlice.actions.removeAdmins(id)));
    if (removeSuccess === true) {
      await Swal.fire('Deleted!', 'Your file has been deleted.', 'success');
    }
  };

  const changeMasterAdmin = async (id) => {
    await Promise.resolve(dispatch(getAdminsSlice.actions.changeAdmins(id)));
  };

  if (changeSuccess && !changeLoading) {
    window.location.reload();
  }

  return (
    <>
      <div className="bg-[url('/src/modules/common/assests/images/home-background.png')] bg-no-repeat bg-cover h-auto">
        <Navbar />
      </div>
      <div className='mt-10 2xl:mt-20 xl:mx-[4rem]'>
        <div className='px-4 sm:px-6 lg:px-8'>
          <div className='sm:flex sm:items-center'>
            <div className='sm:flex-auto'>
              <h1 className='text-xl font-semibold text-gray-900'>Owners</h1>
              <p className='mt-2 text-sm text-gray-700'>
                A list of all the owners in Green Art Coin NFT marketplace
                including their name, wallet address, email and role.
              </p>
            </div>
            {connectivity?.account === master && (
              <div className='mt-4 sm:mt-0 sm:ml-16 sm:flex-none'>
                <Link to='/admin/add'>
                  <button
                    type='button'
                    className='inline-flex items-center justify-center rounded-md border border-transparent bg-gradient-to-b from-[#274728] to-[#40A838] px-4 py-2 text-sm font-medium text-white shadow-sm shadow-green-500/50 hover:shadow-green-500/75  focus:outline-none sm:w-auto'
                  >
                    Add owner
                  </button>
                </Link>
              </div>
            )}
            {connectivity?.account === master && (
              <div className='mt-4 sm:mt-0 sm:ml-4 sm:flex-none'>
                {/* <Link to='/admin/add'> */}

                <button
                  type='button'
                  onClick={() => setIsOpen(true)}
                  className='inline-flex items-center justify-center rounded-md border border-transparent bg-gradient-to-b from-[#274728] to-[#40A838] px-4 py-2 text-sm font-medium text-white shadow-sm shadow-green-500/50 hover:shadow-green-500/75  focus:outline-none sm:w-auto'
                >
                  Change master
                </button>

                {/* </Link> */}
              </div>
            )}
          </div>
          <div className='mt-8 flex flex-col'>
            <div className='-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8'>
              <div className='inline-block min-w-full py-2 align-middle md:px-6 lg:px-8'>
                <div className='overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg'>
                  <table className='min-w-full divide-y divide-gray-300'>
                    <thead className='bg-gray-50'>
                      <tr>
                        <th
                          scope='col'
                          className='py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6'
                        >
                          Name
                        </th>
                        <th
                          scope='col'
                          className='px-3 py-3.5 text-left text-sm font-semibold text-gray-900'
                        >
                          Wallet address
                        </th>
                        <th
                          scope='col'
                          className='px-3 py-3.5 text-left text-sm font-semibold text-gray-900'
                        >
                          Email
                        </th>
                        <th
                          scope='col'
                          className='px-3 py-3.5 text-left text-sm font-semibold text-gray-900'
                        >
                          Role
                        </th>
                        <th
                          scope='col'
                          className='relative py-3.5 pl-3 pr-4 sm:pr-6'
                        >
                          <span className='sr-only'>Edit</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody className='divide-y divide-gray-200 bg-white'>
                      {adminsList
                        ?.filter((data) => data !== null)
                        .map((admin) => (
                          <tr key={admin?.id}>
                            <td className='whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6'>
                              {admin?.name}
                            </td>
                            <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500'>
                              {admin?.wallet}
                            </td>
                            <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500'>
                              {admin?.email}
                            </td>
                            <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500'>
                              {admin?.wallet === master ? (
                                <span>Main Admin</span>
                              ) : (
                                <span>Admin</span>
                              )}
                            </td>
                            {connectivity?.account === master && (
                              <td className='relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6'>
                                <button
                                  type='button'
                                  disabled={removeLoader}
                                  onClick={() => {
                                    if (
                                      adminsList?.filter(
                                        (data) => data !== null
                                      ).length > 1 &&
                                      admin?.wallet !== connectivity?.account
                                    ) {
                                      Swal.fire({
                                        title: 'Are you sure?',
                                        text: "You won't be able to revert this!",
                                        icon: 'warning',
                                        showCancelButton: true,
                                        confirmButtonColor: '#3085d6',
                                        cancelButtonColor: '#d33',
                                        confirmButtonText: 'Yes, delete it!',
                                      }).then(async (result) => {
                                        if (result.isConfirmed) {
                                          await removeAdmin(admin?.id);
                                        }
                                      });
                                    } else if (
                                      admin?.wallet === connectivity?.account
                                    ) {
                                      toast(
                                        'You can not remove your own account.',
                                        {
                                          duration: 2000,
                                          icon: '⚠️',
                                        }
                                      );
                                    } else {
                                      toast(
                                        'You should keep at least one owner.',
                                        {
                                          duration: 2000,
                                          icon: '⚠️',
                                        }
                                      );
                                    }
                                  }}
                                  className='text-green-600 hover:text-green-900'
                                >
                                  Remove
                                  <span className='sr-only'>
                                    , {admin?.name}
                                  </span>
                                </button>
                              </td>
                            )}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toaster position='bottom-center' />
      <ChangeModel
        setIsOpen={(value) => setIsOpen(value)}
        isOpen={isOpen}
        steps={null}
        title='Change the master admin.'
      >
        <div className='w-full px-4 py-16'>
          <div className='mx-auto w-full max-w-md'>
            <RadioGroup value={selected} onChange={setSelected}>
              <div className='mb-4'>
                <RadioGroup.Label className='text-white'>
                  Choose the new master.
                </RadioGroup.Label>
              </div>

              <div className='space-y-2'>
                {adminsList
                  ?.filter((data) => data !== null && data?.wallet !== master)
                  ?.map((admin) => (
                    <RadioGroup.Option
                      key={admin?.wallet}
                      value={admin}
                      className={({ active, checked }) =>
                        `${
                          active
                            ? 'ring-0 ring-white ring-opacity-60 ring-offset-0 ring-offset-sky-300'
                            : ''
                        }
                  ${
                    checked
                      ? 'bg-gradient-to-b from-[#274728] to-[#40A838]  bg-opacity-75 text-white'
                      : 'bg-white'
                  }
                    relative flex cursor-pointer rounded-lg px-5 py-4 shadow-md focus:outline-none`
                      }
                    >
                      {({ checked }) => (
                        <div className='flex w-full items-center justify-between'>
                          <div className='flex items-center'>
                            <div className='text-sm'>
                              <RadioGroup.Label
                                as='p'
                                className={`font-medium ${
                                  checked ? 'text-white' : 'text-gray-900'
                                }`}
                              >
                                {admin.name}
                              </RadioGroup.Label>
                              <RadioGroup.Description
                                as='span'
                                className={`text-xs ${
                                  checked ? 'text-sky-100' : 'text-gray-500'
                                }`}
                              >
                                <p>{admin?.email}</p>
                                <p>{admin?.wallet}</p>
                              </RadioGroup.Description>
                            </div>
                          </div>
                          {checked && (
                            <div className='shrink-0 text-white'>
                              <CheckIcon className='h-6 w-6' />
                            </div>
                          )}
                        </div>
                      )}
                    </RadioGroup.Option>
                  ))}
              </div>
            </RadioGroup>
          </div>
        </div>
        <div className='flex justify-center'>
          <div className='mt-4 sm:mt-0 sm:flex-none'>
            {/* <Link to='/admin/add'> */}
            {changeLoading ? (
              <button
                // onClick={handleSubmit}
                type='submit'
                disabled
                className='bg-gradient-to-b from-[#274728] to-[#40A838] px-6 py-3 text-white rounded-lg font-medium flex cursor-wait'
              >
                <svg
                  className='mr-3 h-5 w-5 animate-spin text-white'
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                >
                  <circle
                    className='opacity-25'
                    cx='12'
                    cy='12'
                    r='10'
                    stroke='currentColor'
                    strokeWidth='4'
                  />
                  <path
                    className='opacity-75'
                    fill='currentColor'
                    d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
                  />
                </svg>
                Loading...
              </button>
            ) : (
              <button
                type='button'
                onClick={() => {
                  if (master === connectivity?.account) {
                    Swal.fire({
                      title: 'Are you sure?',
                      text: "You won't be able to revert this!",
                      icon: 'warning',
                      showCancelButton: true,
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#d33',
                      confirmButtonText: 'Yes, change it!',
                    }).then(async (result) => {
                      if (result.isConfirmed) {
                        await changeMasterAdmin(selected?.id);
                      }
                    });
                  } else {
                    toast('You should keep at least one owner.', {
                      duration: 2000,
                      icon: '⚠️',
                    });
                  }
                }}
                className='inline-flex items-center justify-center rounded-md border border-transparent bg-gradient-to-b from-[#274728] to-[#40A838] px-4 py-2 text-sm font-medium text-white shadow-sm shadow-green-500/50 hover:shadow-green-500/75  focus:outline-none sm:w-auto'
              >
                Change master
              </button>
            )}

            {/* </Link> */}
          </div>
        </div>
      </ChangeModel>
    </>
  );
};

export default Admin;
